(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"]) return;
  try {
    
  const popperButton = document.querySelector("#popper-button");
  const popperPopup = document.querySelector("#tooltip");

  let popperInstance = null;

// create popper instance
  function createInstance() {
    popperInstance = Popper.createPopper(popperButton, popperPopup, {
      placement: changePlacement(),
      modifiers: [
        {
          name: "offset", // offsets popper from the reference/button
          options: {
            offset: [0, 12]
          }
        }, {
          name: "flip", // flips popper with allowed placements
          options: {
            allowedAutoPlacements: ["right", "bottom", "top"],
            rootBoundary: "document"
          }
        }
      ]
    });
  }

// destroy popper instance
  function destroyInstance() {
    if (popperInstance) {
      popperInstance.destroy();
      popperInstance = null;
    }
  }

// show and create popper
  function showPopper() {
    popperPopup.setAttribute("show-popper", "");
    createInstance();
  }

// hide and destroy popper instance
  function hidePopper() {
    popperPopup.removeAttribute("show-popper");
    destroyInstance();
  }

// toggle show-popper attribute on popper to hide or show it with CSS
  function togglePopper() {
    if (popperPopup.hasAttribute("show-popper")) {
      hidePopper();
    } else {
      showPopper();
    }
  }

// execute togglePopper function when clicking the popper reference/button
  popperButton.addEventListener("click", function(e) {
    e.preventDefault();
    togglePopper();
  });

  function changePlacement() {
    if (window.innerWidth < 640) {
      return 'bottom'
    } else {
      return 'right'
    }
  }

  $('.hero .bg-purple').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.listing').offset().top + 100
    }, 500);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  jQuery(document).ready(function($) {
    $(".clickable-row").click(function() {
      window.location = $(this).data("href");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-listing"]) return;
  try {
    
  var titles = document.querySelectorAll('.title-move');
  titles.forEach(function(title) {
    var titleHeight = title.offsetHeight;
    title.style.marginBottom = '-' + titleHeight + 'px';
  });

  } catch(e) { console.error(e); }
})();
})();
